import React from 'react';
import { Col, Button, message } from 'antd';

import { _getagreementlist } from '../../utils/api';

import './index.scss';

class Protocol extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageLoad: false,                    // 页面loading
            agreeList: [],                      // 协议列表
        };
    };

    componentDidMount = () => {
        this.init();
    };

    /** 页面初始化 */
    init = () => {
        /** 获取协议列表 */
        this.setState({ pageLoad: true });
        _getagreementlist({}).then(res => {
            this.setState({ pageLoad: false });
            if (res.code === 200) {
                this.setState({ agreeList: res.data })
            } else {
                message.error(res.msg);
            }
        })
    };

    /** 查看协议详情 */
    toAgreeDetail = id => {
        window.open(`/#/agreementdetail?id=${id}`, '_blank', 'noopener,noreferrer');
    };

    render() {
        const { agreeList } = this.state;
        const { publicView } = this.props;
        const protocolContent = (
            <div className={`protocol${publicView ? ' protocol-public' : ''}`}>
                <h3 className="protocol-title">平台协议规则</h3>
                {
                    (agreeList && agreeList.length) ?
                    agreeList.map(item => (
                        <div key={item.id} className="agree-item">
                            <span className="agree-name">{item.name}</span>
                            <span className="flexG"></span>
                            <div>
                                <Button type="link" onClick={() => this.toAgreeDetail(item.id)}>查看更多》</Button>
                            </div>
                        </div>
                    )) : ''
                }
            </div>
        );

        if (publicView) {
            return (
                <div className="protocol-public-page">
                    {protocolContent}
                </div>
            );
        }

        return (
            <Col lg={16} xs={24} >
                {protocolContent}
            </Col>
        )
    }

}

export default Protocol;
